import React, { useContext, useState, useEffect, useRef } from 'react'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import { initialFunction } from '@/product/components/species/dynamic/common/FieldFunction'
import ProductCommonContext from '@/product/context/common/commonContext'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'

const DynamicDropdown = (props) => {
    const { alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)
    const { allCountries, allStates, allCities } =
        useContext(ProductCommonContext)

    const [reload, setReload] = useState(false)
    const [fieldValue, setFieldValue] = useState([])
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [mapDataValue, setMapDataValue] = useState([])
    const [withId, setWithId] = useState(true)
    const referenceFormik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {},
    })

    //For Dynamic Dropdown
    const subStateOptions = (data) => {
        let valueDrop = allStates
            .filter(
                (state) =>
                    (referenceFormik.values.country
                        ? referenceFormik.values.country.indexOf(
                              state.countryCode
                          ) !== -1
                        : global.defaultCountry.indexOf(state.countryCode) !==
                          -1) &&
                    global.ignoreStates.indexOf(state.isoCode) === -1
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.isoCode
                return busCategoryChanged
            })
        return valueDrop
    }

    const subCityOptions = (data) => {
        console.log(allCities, 'alll')
        console.log(formik.values.country, formik.values.state, 'stato')
        let valueDrop = allCities
            .filter((state) =>
                formik.values.country && formik.values.state
                    ? formik.values.country.indexOf(state.countryCode) !== -1 &&
                      formik.values.state.indexOf(state.stateCode) !== -1
                    : global.defaultCountry.indexOf(state.countryCode) !== -1
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.name
                return busCategoryChanged
            })
        console.log(valueDrop, 'dropcity')
        return valueDrop
    }

    const subLevelOptions = (data) => {
        let valueDrop = alldata_all_dropdown
            .filter((subcat) => {
                if (
                    referenceFormik.values[data.sub_field] &&
                    parseInt(subcat.level, 10) === parseInt(data.sub_level, 10)
                ) {
                    if (
                        parseInt(subcat.active, 10) === 1 ||
                        (referenceFormik.values[data.name] &&
                            referenceFormik.values[data.name] === subcat.id)
                    ) {
                        return (
                            parseInt(
                                referenceFormik.values[data.sub_field],
                                10
                            ) === parseInt(subcat.level_id, 10)
                        )
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
            .map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.description
                subCategoryChanged.value = subcat.id
                return subCategoryChanged
            })
        return valueDrop
    }

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })
    const showWithId = (data) => {
        let value = []
        if (data && data.length && withId) {
            data.map((val) => {
                let obj = {}
                obj.show = `${val.show} - ${val.value}`
                obj.value = val.value
                value.push(obj)
            })
        }
        return value.length ? value : data
    }
    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((data) => {
                if (
                    data.type === 'select' &&
                    parseInt(data.sub_select, 10) === 1
                ) {
                    if (parseInt(data.sub_level, 10) > 0) {
                        data.options = subLevelOptions(data)
                    }
                }
                if (data.type === 'select' && data.name === 'state') {
                    data.options = subStateOptions(data)
                }
                if (data.type === 'select' && props.showWithId) {
                    data.options = showWithId(data.options)
                }
            })
            setFieldValue(tempMapData)
            setWithId(false)
        }
        setReload(!reload)
    }, [referenceFormik.values])

    useEffect(() => {
        setInitialValues({})
        setMapDataValue([])

        if (props.arrayValue.length) {
            let mapValueArray = props.arrayValue

            let { tempMapData, show } = initialFunction(
                mapValueArray,
                alldata_all_dropdown,
                subLevelOptions,
                allCountries,
                subStateOptions,
                subCityOptions,
                allLocations
            )
            setInitialValues({ ...show })
            setInitialEmptyValues({ ...show })
            setMapDataValue(tempMapData)
        }
    }, [props.arrayValue])
    //

    const filedArray = {
        formik: referenceFormik,
        data: fieldValue,
    }

    return (
        <>
            {reload}
            {filedArray?.data?.length ? (
                <div className="row">{Object.values(mapData(filedArray))}</div>
            ) : null}
            <table className="table text-left">
                <tbody>
                    {Object.keys(initialValues).map((buscat) => {
                        return (
                            <tr>
                                <th scope="row">{buscat} dropdown id:</th>
                                <td className="text-right">
                                    {Array.isArray(
                                        referenceFormik.values[buscat]
                                    ) &&
                                    referenceFormik.values[buscat].length > 0
                                        ? referenceFormik.values[buscat].join(
                                              ','
                                          )
                                        : referenceFormik.values[buscat] &&
                                          !Array.isArray(
                                              referenceFormik.values[buscat]
                                          )
                                        ? referenceFormik.values[buscat]
                                        : 'N/A'}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

export default DynamicDropdown
